
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    width: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: '#222020',
    },
  },
})
